import React from 'react';

import { Heading, Text, VStack } from '../../core-ui';
import { Link } from '../Navigation';

export function SenderAddressRequired() {
  return (
    <VStack align="stretch" p={10}>
      <Heading>{t('Sending Addresses Required')}</Heading>
      <Text>
        {t(
          'You need to first setup and verify a sending address before you can send emails.',
        )}
      </Text>
      <Text>
        {t.jsx('Go to <link>Sending Addresses</link>.', {
          link: (content) => (
            <Link to={['/mailer/settings']} variant="blue">
              {content}
            </Link>
          ),
        })}
      </Text>
    </VStack>
  );
}
